type ProductLevel = "Introductory" | "Intermediate" | "Advanced";

const LEVEL_PRIORITY: Record<ProductLevel, number> = {
  Introductory: 1,
  Intermediate: 2,
  Advanced: 3,
};
// This is a temporary fix. We need to investigate why we are getting multiple levels in the product summaries.
export const getHighestLevel = (
  levels: string | string[] | null | undefined,
): ProductLevel | undefined => {
  if (!levels) return undefined;
  const levelArray = Array.isArray(levels) ? levels : [levels];
  const validLevels = levelArray.filter(
    (l): l is ProductLevel => l in LEVEL_PRIORITY,
  );
  if (!validLevels.length) return undefined;
  return validLevels.reduce((highest, current) =>
    LEVEL_PRIORITY[current] > LEVEL_PRIORITY[highest] ? current : highest,
  );
};
